<template>
  <v-card class="h-100">
    <v-card-title primary-title>
      Tagi
    </v-card-title>

    <v-card-text>
      <v-autocomplete
        v-if="editable"
        :value="value"
        :items="filtersOptions.tags"
        placeholder="Wybierz tagi projektu"
        item-text="name"
        item-value="id"
        v-bind="staticData.chipsMultiselectProps"
        @input="$emit('input', $event)"
      />
      <div v-else>
        <template v-if="value.length">
          <v-chip
            v-for="tag in value"
            :key="'tag'+tag.id"
            class="mr-2 mb-2"
            small
            color="primary"
          >
            {{ tag.name }}
          </v-chip>
        </template>
        <div
          v-else
          class="primary--text text-body-2"
        >
          Brak dodanych tagów
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import props from '@/helpers/componentsProps';

export default {
  props: {
    value: { // tags
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    staticData: {
      chipsMultiselectProps: props.chipsMultiselect,
    },
  }),
  computed: {
    ...mapState('filters', [
      'filtersOptions',
    ]),
  },
};
</script>
